"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnimePropsAdapter = /** @class */ (function () {
    function AnimePropsAdapter() {
    }
    AnimePropsAdapter.convertAnimeAnimation = function (data) {
        var animationTypeData = {};
        // combine animation type properties into single object
        data.animTypes.forEach(function (animType) {
            Object.assign(animationTypeData, animType);
        });
        var convertedAnimeProps = Object.assign(animationTypeData, {
            delay: data.delay || 0,
            duration: data.animationDuration || 3000,
            easing: data.easing || 'linear',
            offset: data.offset || 0,
            targets: data.animationOnElem || '',
        });
        return convertedAnimeProps;
    };
    return AnimePropsAdapter;
}());
exports.default = AnimePropsAdapter;
//# sourceMappingURL=anime-props-adapter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Animate/services/adapters/anime-props-adapter.js
// module id = 1101
// module chunks = 8